var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"wrap-page-loading"},_vm._l((9),function(i){return _c('b-col',{key:i,staticClass:"col",attrs:{"cols":"12","md":"4"}},[_c('Skeleton',{attrs:{"width":"100%","height":"20em"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }